import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { TabContext } from '../../context/tabContext';
import { AuthContext } from '../../context/UserContext';
import TabHeader from '../tab-header';
import LoginMessage from '../login-message';
import ShareComponent from '../share-url';

import './bottom-search.scss';

interface IProps {
  inputError: string;
  isFetching: boolean;
  numberOfResult: number;
  searchText: string;
  productDetail: any;
  vendorName: string | undefined;
  isMultipleProducts: boolean;
  showTabHeader: boolean;
  currentUrl: string;
  isHasMyList: boolean;
  getTabId: (tabId: string) => void;
  shareBtnHandler: () => void;
}

export const BottomSearch: React.FC<IProps> = (props) => {
  const { tabId } = useContext(TabContext);
  const { userData } = useContext(AuthContext);

  const {
    inputError,
    isFetching,
    numberOfResult,
    searchText,
    currentUrl,
    productDetail,
    vendorName,
    isMultipleProducts,
    showTabHeader,
    isHasMyList,
    getTabId,
    shareBtnHandler
  } = props;

  const { t } = useTranslation();

  return (
    <div className="bottom-search-container">
      <div className="tab-header-share-btn-login">
        {!isFetching && searchText && (
          <>
            <div className="tab-header-login-container">
              <div className="number-result-and-tab-part-container">
                <div className="mb-0" data-testid="table-length">
                  {numberOfResult > 0 &&
                    tabId !== 'tabReverseLookup' &&
                    !isMultipleProducts ? (
                    <div>
                      <h2 style={{ marginLeft: 3 }}>
                        {`${numberOfResult}  ${t('xref-matches-for')} ${
                          searchText
                          } ${
                            productDetail &&
                            productDetail.length >= 2 &&
                            vendorName
                            ? '(' + vendorName + ')'
                            : ''
                          }`}{' '}
                      </h2>
                    </div>
                  ) : (
                    '--'
                  )}
                </div>

                {showTabHeader && (
                  <div className="d-flex tab-part-container align-items-center">
                    <TabHeader tabId={getTabId} tabProp={tabId} isHasMyList={isHasMyList} />
                  </div>
                )}
              </div>

              {!userData.IsLoggedIn && (
                <div className="part-and-login-container">
                  <LoginMessage
                    message={t('xref-login-msg')}
                    currentUrlToRedirect={currentUrl}
                    inputError={inputError}
                  ></LoginMessage>
                </div>
              )}
            </div>
            <ShareComponent
              shareBtnHandler={shareBtnHandler}
              isHasMyList={isHasMyList} />
          </>
        )}
      </div>
    </div>
  );
};

export default BottomSearch;
